const APP_DOWNLOAD_LOCAL_STORAGE_KEYS = {
    LEGACY_APP_DOWNLOAD_DATA: 'appDownload',
    APP_DOWNLOAD_DATA: 'appDownloadData',
} as const;

const APP_DOWNLOAD_SESSION_STORAGE_KEYS = {
    SEEN: 'appDownloadSeen',
} as const;

const APP_DOWNLOAD_MODAL_TYPES = {
    appDownloadModalPrompt: 'appDownloadModalPrompt',
    appDownloadModalContactSeller: 'appDownloadModalContactSeller',
    appDownloadModalOfferSubmitted: 'appDownloadModalOfferSubmitted',
    appDownloadModalItemSaved: 'appDownloadModalItemSaved',
} as const;

const DAYS_SINCE_USED_APP = 90;

export {
    APP_DOWNLOAD_LOCAL_STORAGE_KEYS,
    APP_DOWNLOAD_SESSION_STORAGE_KEYS,
    APP_DOWNLOAD_MODAL_TYPES,
    DAYS_SINCE_USED_APP,
};
